import { ActionBase } from '../../../core/store/action/ActionBase';
import { DateFramedMessageModel } from '../../models/DateFramedMessageModel';

export const EXPIRE_BROADCAST_SUCCESS_ACTION = '[Configuration] Messages Expire Broadcast Success Action';

export class ExpireBroadcastSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = EXPIRE_BROADCAST_SUCCESS_ACTION;

  constructor(public payload: { expiredBroadcast: DateFramedMessageModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ExpireBroadcastSuccessAction.ts